export function formatTimeOnMarket(days: number): string {
  if (days < 30) {
    return '<30d';
  }
  return `${days}d`;
}
